<template>
  <div class="footMain" style="text-align:center">
    <div class="links">
        <p>
          <a href="/main/about.htm" target="_blank">关于我们</a>
          |
          <a href="/main/copyright.htm" target="_blank">版权声明</a>
          |
          <a href="/main/lineService.htm" target="_blank">在线客服</a>
          |
          <a href="/main/help.htm" target="_blank">常见问题</a>
          |
          <a href="/main/readme.htm" target="_blank">积分说明</a>
          |
          <a href="/main/partnership.htm" target="_blank">商务合作</a>
          |
          <a href="/main/contact.htm" target="_blank">联系我们</a>
        </p>
        <p>
          <a href="https://beian.miit.gov.cn" target="_blank">京ICP备14027621号-3</a> 京网文(2021)2508-690号 增值电信业务经营许可证京ICP证150810号
        </p>
        <p>
          © 2018
          <span>中文在线</span> 书香中国为中文在线旗下网站未经许可严禁转载
        </p>
    </div>
    <img class="footer-img" src="../../assets/img/pc/footer/footer_bg.png">
  </div>
</template>

<script>
export default {
  name: "footer",
  props: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
$fontColor:#fff;
.footMain{
  width: 100%;
  height: 3.7rem;
  color: $fontColor;
  font-size: 0.14rem;
  position:relative;
  .links{
    width: 100%;
    text-align: center;
    z-index: 3;
    position: relative;
  }
  .footer-img{
    width: 100%;
    height: auto;
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 2;
  }
  a{
    color: $fontColor;
    font-size: 0.14rem;
    color: $fontColor;
  }
  p{
    line-height: 0.4rem;
  }
}
</style>
